export default __webpack_public_path__ + "files/tennessee_stations_v3-a23f18c60a6cd8bd441448b61107dbc4.pbf";